import React, { useState } from "react";
import "./footer.css";
import FooterModal from "./FooterModal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { themeContext } from "../../Context/Context";
import { useContext } from "react";

const Footer = () => {
  const [modalContent, setModalContent] = useState(null);
  const [email, setEmail] = useState("");
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  const handleOpenModal = (policyType) => {
    setModalContent(policyType);
  };

  const handleCloseModal = () => {
    setModalContent(null);
  };
  const handleScroll = (event, id) => {
    event.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      const offset = 100;
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: elementPosition - offset,
        behavior: "smooth",
      });
    }
  };
  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const response = await axios.post("http://localhost:8000/api/subscribe", {
        email,
      });
      toast.success(response.data.message);
      setEmail("");
    } catch (error) {
      if (
        error.response &&
        error.response.data.message === "Email is already subscribed"
      ) {
        toast.info(error.response.data.message); // Info message for already subscribed email
      } else {
        toast.error("Subscription failed. Please try again."); // General error message
      }
    }
  };

  return (
    <footer>
      <div className="footer-container">
        <div className="footerTop">
          {/* Contact Information */}
          <div className="footer-section contact-info">
            <h4
              style={{
                color: darkMode ? "#305d78" : "#456a80",
              }}
            >
              Contact Information
            </h4>
            <div className="contactInfo">
              <p>W2 - Westminster - London</p>
              <p>dev.mohamed.ali1@gmail.com</p>
              <a href="https://github.com/devMoAli">Github.com/devMoAli</a>
              <p>Phone: +44 7770799878</p>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section quick-links">
            <h4
              style={{
                color: darkMode ? "#305d78" : "#456a80",
              }}
            >
              Quick Links
            </h4>
            <div className="links-container">
              <div className="leftQ">
                <ul>
                  <li>
                    <a href="#intro" onClick={(e) => handleScroll(e, "intro")}>
                      Top
                    </a>
                  </li>
                  <li>
                    <a
                      href="#services"
                      onClick={(e) => handleScroll(e, "services")}
                    >
                      Services
                    </a>
                  </li>
                  <li>
                    <a
                      href="#experience"
                      onClick={(e) => handleScroll(e, "experience")}
                    >
                      Experience
                    </a>
                  </li>
                </ul>
              </div>
              <div className="rightQ">
                <ul>
                  <li>
                    <a
                      href="#portfolio"
                      onClick={(e) => handleScroll(e, "portfolio")}
                    >
                      Projects
                    </a>
                  </li>
                  <li>
                    <a
                      href="#testimonials"
                      onClick={(e) => handleScroll(e, "testimonials")}
                    >
                      Testimonials
                    </a>
                  </li>
                  <li>
                    <a
                      href="#contact"
                      onClick={(e) => handleScroll(e, "contact")}
                    >
                      Contact
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Follow Us */}
          <div className="footer-section social-media">
            <h4
              style={{
                color: darkMode ? "#305d78" : "#456a80",
              }}
            >
              Follow Us
            </h4>
            <p>Stay connected with us on social media.</p>
            <div className="social-icons">
              <abbr title="Email me">
                <a href="mailto:dev.mohamed.ali1@gmail.com">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1em"
                    height="1em"
                    viewBox="0 0 512 512"
                  >
                    <path
                      fill="#96a9b2"
                      d="M511.824 425.007c1.941-5.245-220.916-173.519-220.916-173.519c-27.9-20.589-42.574-20.913-70.164 0c0 0-222.532 168.138-220.659 173.311l-.045.038c.023.045.06.076.091.117a48.5 48.5 0 0 0 8.119 14.157c1.473 1.786 3.248 3.282 4.955 4.837l-.083.064c.136.121.317.177.453.298c7.235 6.454 16.359 10.634 26.495 11.827c.159.019.287.102.446.121h.612c1.541.147 3.006.517 4.584.517h420.721c20.717 0 38.269-13.028 45.241-31.291c.083-.136.211-.234.287-.374z"
                    ></path>
                    <path
                      fill="#b9c5c6"
                      d="M256.133 232.176L1.216 423.364V152.515c0-26.4 21.397-47.797 47.797-47.797h414.24c26.4 0 47.797 21.397 47.797 47.797v270.849z"
                    ></path>
                    <path
                      fill="#edece6"
                      d="m4.189 135.896l217.645 170.949c27.47 20.271 41.918 20.591 69.083 0L508.22 136.167c-3.77-6.834-9.414-12.233-15.869-16.538l2.989-2.342c-7.295-6.641-16.62-10.946-26.971-12.058l-424.455.015c-10.322 1.097-19.662 5.417-26.942 12.043l2.967 2.313c-6.38 4.245-11.972 9.551-15.75 16.296"
                    ></path>
                    <path
                      fill="#dce2e2"
                      d="M4.118 136.254C2.207 141.419 221.63 307.099 221.63 307.099c27.47 20.271 41.918 20.591 69.083 0c0 0 219.103-165.546 217.258-170.64l.045-.037c-.022-.045-.059-.074-.089-.115a47.7 47.7 0 0 0-7.994-13.939c-1.45-1.759-3.198-3.231-4.878-4.763l.082-.063c-.134-.119-.312-.175-.446-.294c-7.124-6.354-16.107-10.47-26.086-11.645c-.156-.019-.283-.1-.439-.119h-.602c-1.517-.145-2.96-.509-4.514-.509H48.81c-20.398 0-37.68 12.828-44.543 30.809c-.082.134-.208.231-.283.368z"
                    ></path>
                    <path
                      fill="#0f93eb"
                      d="M291.401 154.645h-38.632a6.155 6.155 0 0 0-6.155 6.155v21.722a6.155 6.155 0 0 0 6.155 6.155h31.415a6.155 6.155 0 0 1 6.155 6.155v11.616a6.155 6.155 0 0 1-6.155 6.155h-31.415a6.155 6.155 0 0 0-6.155 6.155v23.578a6.155 6.155 0 0 0 6.155 6.155h41.316a6.155 6.155 0 0 1 6.155 6.155v12.441a6.155 6.155 0 0 1-6.155 6.155h-75.76a6.155 6.155 0 0 1-6.155-6.155V136.461a6.155 6.155 0 0 1 6.155-6.155h74.81c3.749 0 6.627 3.322 6.092 7.033l-1.733 12.028a6.156 6.156 0 0 1-6.093 5.278"
                    ></path>
                  </svg>
                </a>
              </abbr>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1em"
                height="1em"
                viewBox="0 0 256 256"
              >
                <g fill="none">
                  <rect
                    width={256}
                    height={256}
                    fill="url(#skillIconsInstagram0)"
                    rx={60}
                  ></rect>
                  <rect
                    width={256}
                    height={256}
                    fill="url(#skillIconsInstagram1)"
                    rx={60}
                  ></rect>
                  <path
                    fill="#fff"
                    d="M128.009 28c-27.158 0-30.567.119-41.233.604c-10.646.488-17.913 2.173-24.271 4.646c-6.578 2.554-12.157 5.971-17.715 11.531c-5.563 5.559-8.98 11.138-11.542 17.713c-2.48 6.36-4.167 13.63-4.646 24.271c-.477 10.667-.602 14.077-.602 41.236s.12 30.557.604 41.223c.49 10.646 2.175 17.913 4.646 24.271c2.556 6.578 5.973 12.157 11.533 17.715c5.557 5.563 11.136 8.988 17.709 11.542c6.363 2.473 13.631 4.158 24.275 4.646c10.667.485 14.073.604 41.23.604c27.161 0 30.559-.119 41.225-.604c10.646-.488 17.921-2.173 24.284-4.646c6.575-2.554 12.146-5.979 17.702-11.542c5.563-5.558 8.979-11.137 11.542-17.712c2.458-6.361 4.146-13.63 4.646-24.272c.479-10.666.604-14.066.604-41.225s-.125-30.567-.604-41.234c-.5-10.646-2.188-17.912-4.646-24.27c-2.563-6.578-5.979-12.157-11.542-17.716c-5.562-5.562-11.125-8.979-17.708-11.53c-6.375-2.474-13.646-4.16-24.292-4.647c-10.667-.485-14.063-.604-41.23-.604zm-8.971 18.021c2.663-.004 5.634 0 8.971 0c26.701 0 29.865.096 40.409.575c9.75.446 15.042 2.075 18.567 3.444c4.667 1.812 7.994 3.979 11.492 7.48c3.5 3.5 5.666 6.833 7.483 11.5c1.369 3.52 3 8.812 3.444 18.562c.479 10.542.583 13.708.583 40.396s-.104 29.855-.583 40.396c-.446 9.75-2.075 15.042-3.444 18.563c-1.812 4.667-3.983 7.99-7.483 11.488c-3.5 3.5-6.823 5.666-11.492 7.479c-3.521 1.375-8.817 3-18.567 3.446c-10.542.479-13.708.583-40.409.583c-26.702 0-29.867-.104-40.408-.583c-9.75-.45-15.042-2.079-18.57-3.448c-4.666-1.813-8-3.979-11.5-7.479s-5.666-6.825-7.483-11.494c-1.369-3.521-3-8.813-3.444-18.563c-.479-10.542-.575-13.708-.575-40.413s.096-29.854.575-40.396c.446-9.75 2.075-15.042 3.444-18.567c1.813-4.667 3.983-8 7.484-11.5s6.833-5.667 11.5-7.483c3.525-1.375 8.819-3 18.569-3.448c9.225-.417 12.8-.542 31.437-.563zm62.351 16.604c-6.625 0-12 5.37-12 11.996c0 6.625 5.375 12 12 12s12-5.375 12-12s-5.375-12-12-12zm-53.38 14.021c-28.36 0-51.354 22.994-51.354 51.355s22.994 51.344 51.354 51.344c28.361 0 51.347-22.983 51.347-51.344c0-28.36-22.988-51.355-51.349-51.355zm0 18.021c18.409 0 33.334 14.923 33.334 33.334c0 18.409-14.925 33.334-33.334 33.334s-33.333-14.925-33.333-33.334c0-18.411 14.923-33.334 33.333-33.334"
                  ></path>
                  <defs>
                    <radialGradient
                      id="skillIconsInstagram0"
                      cx={0}
                      cy={0}
                      r={1}
                      gradientTransform="matrix(0 -253.715 235.975 0 68 275.717)"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#fd5"></stop>
                      <stop offset={0.1} stopColor="#fd5"></stop>
                      <stop offset={0.5} stopColor="#ff543e"></stop>
                      <stop offset={1} stopColor="#c837ab"></stop>
                    </radialGradient>
                    <radialGradient
                      id="skillIconsInstagram1"
                      cx={0}
                      cy={0}
                      r={1}
                      gradientTransform="matrix(22.25952 111.2061 -458.39518 91.75449 -42.881 18.441)"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#3771c8"></stop>
                      <stop offset={0.128} stopColor="#3771c8"></stop>
                      <stop offset={1} stopColor="#60f" stopOpacity={0}></stop>
                    </radialGradient>
                  </defs>
                </g>
              </svg>
              <abbr title="Facebook">
                <a href="https://www.facebook.com/Mo.Ali666666">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1em"
                    height="1em"
                    viewBox="0 0 128 128"
                  >
                    <rect
                      width={118.35}
                      height={118.35}
                      x={4.83}
                      y={4.83}
                      fill="#5a85e2"
                      rx={6.53}
                      ry={6.53}
                    ></rect>
                    <path
                      fill="#fff"
                      d="M86.48 123.17V77.34h15.38l2.3-17.86H86.48v-11.4c0-5.17 1.44-8.7 8.85-8.7h9.46v-16A127 127 0 0 0 91 22.7c-13.62 0-23 8.3-23 23.61v13.17H52.62v17.86H68v45.83z"
                    ></path>
                  </svg>
                </a>
              </abbr>
              <abbr title="Github">
                <a
                  href="https://github.com/devMoAli"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1.5rem"
                    height="1.5rem"
                    viewBox="0 0 256 259.3"
                  >
                    <path
                      fill="#9edcf2"
                      d="M200.9 199.8c0 13.9-32.2 25.1-71.9 25.1s-71.9-11.3-71.9-25.1c0-13.9 32.2-25.1 71.9-25.1s71.9 11.2 71.9 25.1m0 0"
                    ></path>
                    <defs>
                      <path
                        id="logosGithubOctocat0"
                        d="M98.1 244.8c1.6 7.5 5.5 11.9 9.4 14.5h41.1c5-3.4 10.1-9.8 10.1-21.8v-31s.6-7.7 7.7-10.2c0 0 4.1-2.9-.3-4.5c0 0-19.5-1.6-19.5 14.4v23.6s.8 8.7-3.8 12.3v-29.2s.3-9.3 5.1-12.8c0 0 3.2-5.7-3.8-4.2c0 0-13.4 1.9-14 17.6l-.3 30h-3.2l-.3-30c-.6-15.6-14-17.6-14-17.6c-7-1.6-3.8 4.2-3.8 4.2c4.8 3.5 5.1 12.8 5.1 12.8v29.5c-4.6-3.3-3.8-12.6-3.8-12.6v-23.6c0-16-19.5-14.4-19.5-14.4c-4.5 1.6-.3 4.5-.3 4.5c7 2.6 7.7 10.2 7.7 10.2v21.7z"
                      ></path>
                    </defs>
                    <clipPath id="logosGithubOctocat1">
                      <use href="#logosGithubOctocat0"></use>
                    </clipPath>
                    <path
                      fill="#7dbce7"
                      d="M200.9 199.8c0 13.9-32.2 25.1-71.9 25.1s-71.9-11.3-71.9-25.1c0-13.9 32.2-25.1 71.9-25.1s71.9 11.2 71.9 25.1m0 0"
                      clipPath="url(#logosGithubOctocat1)"
                    ></path>
                    <path
                      fill="#9edcf2"
                      d="m46.9 125.9l-2.1 7.2s-.5 2.6 1.9 3.1c2.6-.1 2.4-2.5 2.2-3.2zm0 0"
                    ></path>
                    <path
                      fill="#010101"
                      d="m255.8 95.6l.2-.9c-21.1-4.2-42.7-4.3-55.8-3.7c2.1-7.7 2.8-16.7 2.8-26.6c0-14.3-5.4-25.7-14-34.3c1.5-4.9 3.5-15.8-2-29.7c0 0-9.8-3.1-32.1 11.8c-8.7-2.2-18-3.3-27.3-3.3c-10.2 0-20.5 1.3-30.2 3.9C74.4-2.9 64.3.3 64.3.3c-6.6 16.5-2.5 28.8-1.3 31.8c-7.8 8.4-12.5 19.1-12.5 32.2c0 9.9 1.1 18.8 3.9 26.5c-13.2-.5-34-.3-54.4 3.8l.2.9c20.4-4.1 41.4-4.2 54.5-3.7c.6 1.6 1.3 3.2 2 4.7c-13 .4-35.1 2.1-56.3 8.1l.3.9c21.4-6 43.7-7.6 56.6-8c7.8 14.4 23 23.8 50.2 26.7c-3.9 2.6-7.8 7-9.4 14.5c-5.3 2.5-21.9 8.7-31.9-8.5c0 0-5.6-10.2-16.3-11c0 0-10.4-.2-.7 6.5c0 0 6.9 3.3 11.7 15.6c0 0 6.3 21 36.4 14.2V177s-.6 7.7-7.7 10.2c0 0-4.2 2.9.3 4.5c0 0 19.5 1.6 19.5-14.4v-23.6s-.8-9.4 3.8-12.6v38.8s-.3 9.3-5.1 12.8c0 0-3.2 5.7 3.8 4.2c0 0 13.4-1.9 14-17.6l.3-39.3h3.2l.3 39.3c.6 15.6 14 17.6 14 17.6c7 1.6 3.8-4.2 3.8-4.2c-4.8-3.5-5.1-12.8-5.1-12.8v-38.5c4.6 3.6 3.8 12.3 3.8 12.3v23.6c0 16 19.5 14.4 19.5 14.4c4.5-1.6.3-4.5.3-4.5c-7-2.6-7.7-10.2-7.7-10.2v-31c0-12.1-5.1-18.5-10.1-21.8c29-2.9 42.9-12.2 49.3-26.8c12.7.3 35.6 1.9 57.4 8.1l.3-.9c-21.7-6.1-44.4-7.7-57.3-8.1c.6-1.5 1.1-3 1.6-4.6c13.4-.5 35.1-.5 56.3 3.7m0 0"
                    ></path>
                    <path
                      fill="#f5ccb3"
                      d="M174.6 63.7c6.2 5.7 9.9 12.5 9.9 19.8c0 34.4-25.6 35.3-57.2 35.3S70.1 114 70.1 83.5c0-7.3 3.6-14.1 9.8-19.7c10.3-9.4 27.7-4.4 47.4-4.4s37-5.1 47.3 4.3m0 0"
                    ></path>
                    <path
                      fill="#fff"
                      d="M108.3 85.3c0 9.5-5.3 17.1-11.9 17.1s-11.9-7.7-11.9-17.1c0-9.5 5.3-17.1 11.9-17.1c6.6-.1 11.9 7.6 11.9 17.1m0 0"
                    ></path>
                    <path
                      fill="#af5c51"
                      d="M104.5 85.5c0 6.3-3.6 11.4-7.9 11.4c-4.4 0-7.9-5.1-7.9-11.4s3.6-11.4 7.9-11.4s7.9 5.1 7.9 11.4m0 0"
                    ></path>
                    <path
                      fill="#fff"
                      d="M172.2 85.3c0 9.5-5.3 17.1-11.9 17.1s-11.9-7.7-11.9-17.1c0-9.5 5.3-17.1 11.9-17.1c6.5-.1 11.9 7.6 11.9 17.1m0 0"
                    ></path>
                    <path
                      fill="#af5c51"
                      d="M168.3 85.5c0 6.3-3.6 11.4-7.9 11.4c-4.4 0-7.9-5.1-7.9-11.4s3.6-11.4 7.9-11.4c4.4 0 7.9 5.1 7.9 11.4m-37.8 15c0 1.6-1.3 3-3 3c-1.6 0-3-1.3-3-3s1.3-3 3-3c1.6 0 3 1.3 3 3m-9.9 7.5c-.2-.5.1-1 .6-1.2s1 .1 1.2.6c.8 2.2 2.8 3.6 5.1 3.6s4.3-1.5 5.1-3.6c.2-.5.7-.8 1.2-.6s.8.7.6 1.2c-1 2.9-3.8 4.9-6.9 4.9s-5.9-2-6.9-4.9m0 0"
                    ></path>
                    <path
                      fill="#c4e5d9"
                      d="M54.5 121.6c0 .8-.9 1.4-2.1 1.4c-1.1 0-2.1-.6-2.1-1.4s.9-1.4 2.1-1.4s2.1.6 2.1 1.4m5.8 3.2c0 .8-.9 1.4-2.1 1.4c-1.1 0-2.1-.6-2.1-1.4s.9-1.4 2.1-1.4s2.1.6 2.1 1.4m3.5 4.2c0 .8-.9 1.4-2.1 1.4c-1.1 0-2.1-.6-2.1-1.4s.9-1.4 2.1-1.4c1.2-.1 2.1.6 2.1 1.4m3.2 4.8c0 .8-.9 1.4-2.1 1.4c-1.1 0-2.1-.6-2.1-1.4s.9-1.4 2.1-1.4c1.2-.1 2.1.6 2.1 1.4m3.5 4.4c0 .8-.9 1.4-2.1 1.4c-1.1 0-2.1-.6-2.1-1.4s.9-1.4 2.1-1.4s2.1.6 2.1 1.4m4.8 3.9c0 .8-.9 1.4-2.1 1.4c-1.1 0-2.1-.6-2.1-1.4s.9-1.4 2.1-1.4c1.2-.1 2.1.6 2.1 1.4m6.7 2.5c0 .8-.9 1.4-2.1 1.4c-1.1 0-2.1-.6-2.1-1.4s.9-1.4 2.1-1.4s2.1.6 2.1 1.4m6.7 0c0 .8-.9 1.4-2.1 1.4c-1.1 0-2.1-.6-2.1-1.4s.9-1.4 2.1-1.4s2.1.6 2.1 1.4m6.8-1.1c0 .8-.9 1.4-2.1 1.4c-1.1 0-2.1-.6-2.1-1.4s.9-1.4 2.1-1.4c1.1 0 2.1.6 2.1 1.4m0 0"
                    ></path>
                  </svg>
                </a>
              </abbr>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1em"
                height="1em"
                viewBox="0 0 72 72"
              >
                <rect
                  width={50}
                  height={50}
                  x={11}
                  y={11}
                  fill="#61b2e4"
                  rx={3}
                ></rect>
                <path fill="#fff" d="M20 30h6v21h-6z"></path>
                <circle cx={23} cy={22} r={3.5} fill="#fff"></circle>
                <path
                  fill="#fff"
                  d="M42.5 35c-2.209 0-4 1.168-4 4.5V51h-6V30h6v2.21h-.002A7.98 7.98 0 0 1 44.5 29.5c4.418 0 8 3.3 8 9V51h-6V39.5c0-3.332-1.79-4.5-4-4.5"
                ></path>
                <g fill="none" stroke="#000" strokeWidth={2}>
                  <rect
                    width={50}
                    height={50}
                    x={11}
                    y={11}
                    strokeMiterlimit={10}
                    rx={3}
                  ></rect>
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M20 30h6v21h-6z"
                  ></path>
                  <circle
                    cx={23}
                    cy={22}
                    r={3.5}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></circle>
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M42.5 35c-2.209 0-4 1.168-4 4.5V51h-6V30h6v2.21h-.002A7.98 7.98 0 0 1 44.5 29.5c4.418 0 8 3.3 8 9V51h-6V39.5c0-3.332-1.79-4.5-4-4.5"
                  ></path>
                </g>
              </svg>
            </div>
          </div>
          {/* Newsletters Stay Updated */}
          <div className="footer-section newsletter">
            <h4
              style={{
                color: darkMode ? "#305d78" : "#456a80",
              }}
            >
              Stay Updated
            </h4>
            <p>
              Subscribe to my newsletter for the latest web development topics,
              new courses and more
            </p>
            <form onSubmit={handleSubmit} className="newsletterForm">
              <input
                type="email"
                value={email}
                onChange={handleEmailChange}
                placeholder="Enter your email"
                required
              />
              <button className="newsletterBtn" type="submit">
                Subscribe
              </button>{" "}
            </form>
          </div>
        </div>
        <div className="footerBottom">
          {/* Terms & Conditions */}
          <div className="tagline">
            <div className="legal">
              <ul>
                <li>
                  <a
                    href="#privacy"
                    onClick={() => handleOpenModal("Privacy Policy Text")}
                  >
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a
                    href="#terms"
                    onClick={() => handleOpenModal("Terms of Service Text")}
                  >
                    Terms of Service
                  </a>
                </li>
                <li>
                  <a
                    href="#cookies"
                    onClick={() => handleOpenModal("Cookies Policy Text")}
                  >
                    Cookies Policy
                  </a>
                </li>
              </ul>
            </div>

            {modalContent && (
              <FooterModal
                policyType={modalContent}
                onClose={handleCloseModal}
              />
            )}
            <p>Building the Future of Web ®</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
